import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import { acceptInvitationApi, getInvitationDetailsApi, rejectInvitationApi } from '../../server/workspace';

const Invitation = () => {
    const { token } = useParams();
    const [workspaceLogo, setWorkspaceLogo] = useState('/images/floworglogo.png');
    const [userName, setUserName] = useState('Guest');
    const [workspaceName, setWorkspaceName] = useState('');
    const [acceptButtonDisabled, setAcceptButtonDisabled] = useState(false);
    const [rejectButtonDisabled, setRejectButtonDisabled] = useState(false);
    const [userExist, setUserExist] = useState(false);
    const [isReady, setIsReady] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getInvitationDetails();
    }, [token]);

    const getInvitationDetails = async () => {
        try {
            const res = await getInvitationDetailsApi(token);

            if (res.userExist) { setUserExist(true); }
            else { setUserExist(false); }

            if (res.workspaceLogo) { setWorkspaceLogo(res.workspaceLogo); }
            else { setWorkspaceLogo('/images/floworglogo.png'); }

            if (res.userName) { setUserName(res.userName); }
            else { setUserName('Guest'); }

            if (res.workspaceName) { setWorkspaceName(res.workspaceName); }
            else { setWorkspaceName(''); }

            setIsReady(true);
        } catch (err) {
            navigate('/sys');
            console.log('catch error => getInvitationDetailsApi: ', err);
        }
    }

    const handleAccept = async () => {
        if (!userExist) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            navigate('/register');
            return;
        }

        setAcceptButtonDisabled(true);
        try {
            await acceptInvitationApi(token);
            setAcceptButtonDisabled(false);
            navigate('/sys');
        } catch (err) {
            console.log('catch error => acceptInvitationApi: ', err);
            setAcceptButtonDisabled(false);
        }
    }

    const handleReject = async () => {
        setRejectButtonDisabled(true);
        try {
            await rejectInvitationApi(token);
            setRejectButtonDisabled(false);
            navigate('/sys');
        } catch (err) {
            console.log('catch error => rejectInvitationApi: ', err);
            setRejectButtonDisabled(false);
        }
    }

    return (
        <div style={{ backgroundColor: '#29303d', width: '100%', height: '100vh' }}>
            {isReady && (
                <Container>
                    <Row className="justify-content-md-center text-center pt-4">
                        <Col sm="12" md="6">
                            <Image src={workspaceLogo} style={{ width: '80%' }} />
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center text-center pt-4">
                        <Col sm="12" md="6">
                            <h3 style={{ color: '#fed78e' }}>Hello {userName}</h3>
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center text-center pt-4">
                        <Col sm="12" md="6">
                            <h3 style={{ color: '#fed78e' }}>You have invitations from {workspaceName} workspace</h3>
                        </Col>
                    </Row>

                    <Row className="justify-content-md-center text-center mt-5">
                        <Col sm="12" md="6">
                            <Button
                                variant="gray"
                                style={{ backgroundColor: '#fed78e', color: '#29303d', width: '150px' }}
                                onClick={handleAccept}
                                disabled={acceptButtonDisabled}
                            >Accept</Button>
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center text-center mt-3">
                        <Col sm="12" md="6">
                            <Button
                                variant="gray"
                                style={{ backgroundColor: '#29303d', color: '#fed78e', width: '150px', border: '1px solid #fed78e' }}
                                onClick={handleReject}
                                disabled={rejectButtonDisabled}
                            >Reject</Button>
                        </Col>
                    </Row>
                </Container>
            )}
        </div>
    );
}

export default Invitation;
